import { createClient } from '@supabase/supabase-js';
import type { Database } from './database.types';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables. Please check your .env file.');
}

// Create Supabase client with enhanced error handling and retry logic
export const supabase = createClient<Database>(
  supabaseUrl,
  supabaseAnonKey,
  {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true
    },
    db: {
      schema: 'public'
    }
  }
);

// Enhanced error handling helper
export const handleSupabaseError = (error: any, context: string) => {
  console.error('Supabase error:', {
    message: error.message,
    code: error.code,
    details: error.details,
    hint: error.hint,
    context,
    timestamp: new Date().toISOString()
  });

  if (error.message?.includes('Database error querying schema')) {
    throw new Error('Unable to connect to the database. Please try again later.');
  }

  if (error.status === 500) {
    throw new Error('Server error. Please try again later.');
  }

  if (error instanceof Error) {
    if (error.message.includes('Failed to fetch')) {
      throw new Error('Network connection error. Please check your internet connection.');
    }
    throw new Error(`Error: ${error.message}`);
  }
  
  throw new Error('An unexpected error occurred. Please try again.');
};